import React from "react";
import { motion } from "framer-motion";
// import { Player } from "@lottiefiles/react-lottie-player"; // Import the Player from Lottie
import dynamic from "next/dynamic";

const Player = dynamic(() => import("@lottiefiles/react-lottie-player")
  .then
  (mod => mod.Player), 
  { ssr: false }
);

function NeetScore() {
  const data = [
    {
      id: 1,
      paragraph:
        "With years of experience and deep insight into the NEET counselling process, we’ve helped thousands of aspirants secure seats in top medical colleges including AIIMS, JIPMER, government, and private institutions. The result say it all.",
      title: "Guided by Experts, Proven by Results",
      img: "assets/jsons/Experienced Team.json", // JSON path
    },
    {
      id: 2,
      paragraph: "We understand that every NEET aspirant is unique. Our NEET counselling approach is fully customized based on your rank, preferences, eligibility, and goals so you always get the best-fit strategy to secure your dream medical seat.",
      title: "Personalized Counselling for Every Student",
      img: "assets/jsons/Comprehensive Support.json",
    },
    {
      id: 3,
      paragraph:
        "From exam prep to final admission, we guide you through every stage: NEET counselling registration, choice filling, document verification, college selection, and more. You’ll never feel lost in the process we’re with you at every step.",
      title: "Complete End-to-End Guidance",
      img: "assets/jsons/Personalized Solution.json",
    },
    {
      id: 4,
      paragraph:
        "Our Advanced tools like Rank Predictor, College Predictor, Cutoff Analysis, and Seat Matrix help you make well-informed decisions backed by real data and previous year trends. No guesswork. Just clarity and confidence.",
      title: "Smart, Data-Driven Decision-Making",
      img: "assets/jsons/Revolutionary Approach.json",
    },
  ];

  return (
    <section className="bg-white w-full flex justify-center">
      <div className="container mx-auto flex flex-col items-center !mb-12">
        {/* Section Title */}
        <div className="text-center ">
          <h2 className="text-2xl md:text-4xl font-semibold mb-[50px] text-[#140342]">
          Why we are 
            <b className="text-orange-400"> ‘UNBEATABLE’ ?</b>
          </h2>
        </div>

        {/* Flexbox layout for two items per row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-center">
          {data.map((item) => (
            <motion.div
              key={item.id}
              className="flex items-center justify-center p-[22.5px] bg-white border-2 border-[#ff9245] rounded-3xl shadow-lg hover:shadow-2xl transition-shadow duration-300 "
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              {/* Left Side Lottie Animation */}
              <div className="flex items-center w-full">
                <Player
                  autoplay
                  loop
                  src={item.img} // Pass the path from data array
                  className="object-contain h-16 w-16"
                />
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-gray-800" style={{ fontSize: "16.875px" }}>
                    {item.title}
                  </h3>
                  <p 
                    className="text-gray-600" 
                    style={{ fontSize: "15px", lineHeight: "1.4" }} // Adjust line height
                  >
                    {item.paragraph}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default NeetScore;
